module.exports = __webpack_public_path__ + "images/components/estimate_banners/form_with_image/products_left_pc_43cc6bee172581074887dc83fecdfcf0.svg";